
import { Vue } from "vue-class-component";

export default class FontSize extends Vue {
  fontSizeClasses = ["smallest", "small", "normal", "medium", "large", "larger", "huge"];

  change(fontSizeClass: string) {
    this.$store.commit("setFontSizeClass", fontSizeClass);
  }
}
